export default "__VITE_ASSET__ee87d340__"